import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "users-grid",
  style: {"margin-top":"-20px"}
}
const _hoisted_2 = {
  class: "card bg-white mb-3",
  style: {"width":"100%","margin-top":"1.3rem","border-radius":"10px"}
}
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-3" }
const _hoisted_6 = { for: "unitOfMeasurement" }
const _hoisted_7 = { class: "input-group mb-3" }
const _hoisted_8 = { class: "input-group mb-3" }
const _hoisted_9 = { class: "col-3" }
const _hoisted_10 = { for: "packageUnit" }
const _hoisted_11 = { class: "input-group mb-3" }
const _hoisted_12 = { class: "col-3" }
const _hoisted_13 = { for: "currencyUnit" }
const _hoisted_14 = { class: "input-group mb-3" }
const _hoisted_15 = { class: "col-3" }
const _hoisted_16 = { for: "tktTex" }
const _hoisted_17 = { class: "input-group mb-3" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = { for: "customRange3" }
const _hoisted_21 = {
  key: 0,
  style: {"position":"absolute","right":"20px"}
}
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-12" }
const _hoisted_25 = {
  key: 0,
  class: "coats-divider"
}
const _hoisted_26 = {
  key: 1,
  class: "row"
}
const _hoisted_27 = {
  class: "col-12",
  style: {"border":"1px solid #e4e4e4","padding":"15px","margin-top":"15px"}
}
const _hoisted_28 = { for: "costFile" }
const _hoisted_29 = { class: "table table-bordered" }
const _hoisted_30 = {
  key: 0,
  class: "ml-6"
}
const _hoisted_31 = { style: {"width":"20%"} }
const _hoisted_32 = {
  class: "action",
  style: {"display":"flex"}
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = ["title"]
const _hoisted_35 = {
  class: "k-button k-button-icontext k-grid-threadUsage",
  href: "/CostFileTemplate.xls",
  download: "",
  style: {"color":"black","border-radius":"3px","margin-right":"8px","width":"27px","height":"27px","display":"inline-flex","align-items":"center","justify-content":"center"}
}
const _hoisted_36 = ["title"]
const _hoisted_37 = {
  class: "custom-file",
  style: {"margin-top":"6px","width":"15%"}
}
const _hoisted_38 = {
  for: "exampleInputFile",
  class: "btn btn-sm btn-primary",
  "aria-describedby": "fileHelp",
  style: {"margin-top":"-6px","background-color":"#0054a6","color":"white"}
}
const _hoisted_39 = {
  key: 1,
  class: "calculation-engine-box"
}
const _hoisted_40 = { class: "engine-header" }
const _hoisted_41 = { class: "calculation-title" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "engine-description" }
const _hoisted_45 = { class: "engine-current" }
const _hoisted_46 = {
  key: 0,
  class: "engine-locked-message"
}
const _hoisted_47 = {
  key: 2,
  class: "calculation-engine-box multi-component-thread-box"
}
const _hoisted_48 = { class: "engine-header" }
const _hoisted_49 = { class: "calculation-title" }
const _hoisted_50 = { class: "engine-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kendo_dropdownlist = _resolveComponent("kendo-dropdownlist")!
  const _component_DialogBox = _resolveComponent("DialogBox")!
  const _component_toggle_button = _resolveComponent("toggle-button")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_ShadeGrouping = _resolveComponent("ShadeGrouping")!
  const _component_CustomSetting = _resolveComponent("CustomSetting")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Accordion, {
      Heading: _ctx.systemConfiguartion,
      Title1: _ctx.measurementUnit,
      Title2: _ctx.currencyUnitVal,
      Title3: _ctx.allowance,
      Value1: _ctx.seamUnitDefaultValue,
      Value2: _ctx.currencyDefaultValue,
      Value3: _ctx.defaultAllowanceVal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("systemConfiguration.seamLengthUnitOfMeasurement")), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      (_ctx.loaded)
                        ? (_openBlock(), _createBlock(_component_kendo_dropdownlist, {
                            key: 0,
                            field: "dropdownId",
                            ref: "dropdownlist",
                            "data-source": _ctx.seamUnitData,
                            index: _ctx.seamUnitDefaultValueIndex,
                            onChange: _ctx.onChange,
                            id: "seamLengthUnitId"
                          }, null, 8, ["data-source", "index", "onChange"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("systemConfiguration.packageUnit")), 1),
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.loaded)
                      ? (_openBlock(), _createBlock(_component_kendo_dropdownlist, {
                          key: 0,
                          "data-source": _ctx.packageUnitData,
                          index: _ctx.packageUnitDefaultValueIndex,
                          id: "packageUnitDataId"
                        }, null, 8, ["data-source", "index"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("systemConfiguration.currencyUnit")), 1),
                  _createElementVNode("div", _hoisted_14, [
                    (_ctx.loaded)
                      ? (_openBlock(), _createBlock(_component_kendo_dropdownlist, {
                          key: 0,
                          "data-source": _ctx.currencyUnitData,
                          index: _ctx.currencyDefaultValueIndex,
                          id: "currencyUnitId"
                        }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode("INR ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["data-source", "index"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("systemConfiguration.tktTex")), 1),
                  _createElementVNode("div", _hoisted_17, [
                    (_ctx.loaded)
                      ? (_openBlock(), _createBlock(_component_kendo_dropdownlist, {
                          key: 0,
                          "data-source": _ctx.tktTexData,
                          index: _ctx.tktTexDefaultValueIndex,
                          id: "tktTexId"
                        }, null, 8, ["data-source", "index"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("systemConfiguration.defaultAllowance")), 1),
                  (_ctx.loaded)
                    ? (_openBlock(), _createElementBlock("output", _hoisted_21, _toDisplayString(this.defaultAllowanceVal) + "%", 1))
                    : _createCommentVNode("", true),
                  (_ctx.loaded)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 1,
                        type: "range",
                        class: "custom-range",
                        min: "0",
                        max: "50",
                        step: "1",
                        value: _ctx.defaultAllowanceVal,
                        id: "customRange3",
                        oninput: "this.previousElementSibling.value = this.value + '%'"
                      }, null, 8, _hoisted_22))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("button", {
                    class: "btn btn-sm mt-2",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSave && _ctx.onSave(...args))),
                    style: {"background-color":"#0054a6","color":"white"}
                  }, _toDisplayString(_ctx.$t("systemConfiguration.update")), 1)
                ])
              ]),
              (+_ctx.activeAccountType == 101)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("systemConfiguration.viewMessage")), 1)
                  ]))
                : _createCommentVNode("", true),
              (+_ctx.activeAccountType == 101)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("systemConfiguration.costFile")), 1),
                      _createElementVNode("table", _hoisted_29, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t("systemConfiguration.name")), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t("systemConfiguration.lastUpdated")), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t("systemConfiguration.action")), 1)
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", null, _toDisplayString(this.costFileName), 1),
                            (_ctx.loaded)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_30, _toDisplayString(this.lastUpdatedTime), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                (_ctx.costFileName != '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                      _createElementVNode("button", {
                                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadCostFile && _ctx.downloadCostFile(...args))),
                                        class: "k-button k-button-icontext k-grid-threadUsage",
                                        style: {"color":"black","border-radius":"3px","margin-right":"8px","width":"27px","height":"27px"}
                                      }, [
                                        _createElementVNode("span", {
                                          class: "k-icon k-i-arrow-down",
                                          title: _ctx.downloadCompleteCostData
                                        }, null, 8, _hoisted_34)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", null, [
                                  _createElementVNode("a", _hoisted_35, [
                                    _createElementVNode("span", {
                                      class: "k-icon k-i-copy",
                                      title: _ctx.downloadBlankTemplate
                                    }, null, 8, _hoisted_36)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      (_ctx.showModal)
                        ? (_openBlock(), _createBlock(_component_DialogBox, {
                            key: 0,
                            jsondata: _ctx.constFileData,
                            importType: 2,
                            title: 'Data Upload'
                          }, null, 8, ["jsondata"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_37, [
                          _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("systemConfiguration.chooseFile")), 1),
                          _createElementVNode("input", {
                            type: "file",
                            id: "exampleInputFile",
                            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
                            ref: "fileToUpload",
                            style: {"display":"none"}
                          }, null, 544),
                          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "custom-file-control form-control-file" }, null, -1))
                        ])
                      ]),
                      (+_ctx.activeAccountType == 101)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t("systemConfiguration.calculationEngine")), 1)
                              ]),
                              _createElementVNode("div", {
                                class: _normalizeClass(["engine-toggle", { disabled: _ctx.isEngineToggleDisabled || _ctx.isCalculationEngineUpdating }])
                              }, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass({ active: _ctx.calculationEngine === 'Seamworks' }),
                                  disabled: _ctx.isEngineToggleDisabled || _ctx.isCalculationEngineUpdating,
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeCalculationEngine('Seamworks')))
                                }, " Seamworks ", 10, _hoisted_42),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass({ active: _ctx.calculationEngine === 'GSD V4' }),
                                  disabled: _ctx.isEngineToggleDisabled || _ctx.isCalculationEngineUpdating,
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeCalculationEngine('GSD V4')))
                                }, " GSD V4 ", 10, _hoisted_43)
                              ], 2)
                            ]),
                            _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t("systemConfiguration.calculationEngineDescription")), 1),
                            _createElementVNode("div", _hoisted_45, [
                              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "info-icon" }, "ⓘ", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t("systemConfiguration.calculationEngineCurrentStatus", { engine: _ctx.calculationEngine })), 1)
                            ]),
                            (_ctx.isEngineToggleDisabled)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "k-icon k-i-lock lock-icon" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("systemConfiguration.calculationEngineLockedMessage", { styleCount: _ctx.styleCount })), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (+_ctx.activeAccountType == 101 && _ctx.showMultiComponentThread)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t("systemConfiguration.multiComponentThread")), 1)
                              ]),
                              _createVNode(_component_toggle_button, {
                                value: _ctx.isMultiComponentThreadEnabled,
                                disabled: _ctx.isMultiComponentThreadUpdating,
                                height: 25,
                                width: 60,
                                checkedText: _ctx.$t('systemConfiguration.on'),
                                uncheckedText: _ctx.$t('systemConfiguration.off'),
                                checkedBg: " #0054a6",
                                uncheckedBg: "lightgrey",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeMultiComponentThread(!_ctx.isMultiComponentThreadEnabled)))
                              }, null, 8, ["value", "disabled", "checkedText", "uncheckedText"])
                            ]),
                            _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t("systemConfiguration.multiComponentThreadDescription")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("div", null, null, -1))
      ]),
      _: 1
    }, 8, ["Heading", "Title1", "Title2", "Title3", "Value1", "Value2", "Value3"]),
    _createVNode(_component_ShadeGrouping),
    (_ctx.loaded && !_ctx.isV4CalculationEngine)
      ? (_openBlock(), _createBlock(_component_CustomSetting, {
          key: 0,
          seamUnitDefaultValue: _ctx.seamUnitDefaultValue,
          seamLengthUnit: _ctx.seamUnitDefaultValueIndex
        }, null, 8, ["seamUnitDefaultValue", "seamLengthUnit"]))
      : _createCommentVNode("", true)
  ]))
}